







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class VueSmartSliderProcess extends Vue {
  name = 'VueSmartSliderProcess';

  @Prop({ required: true, type: Number, default: 0 }) readonly left!: number;

  @Prop({ required: true, type: Number, default: 0 }) readonly height!: number;

  @Prop({ required: true, type: String, default: '' }) readonly transition!: string;

  get processHeight(): string {
    return `${this.height}px`;
  }

  get processWidth(): string {
    return this.left > 0 ? `${this.left}px` : '0px';
  }
}
